import React from 'react';
import { formatCurrency } from '../../../../../util/util';
import { Tag } from '../../../../../components/Tag/Tag';

export function PriceCell({
  price,
  title,
  incoming,
  skipHighlight,
}: {
  price?: number | null;
  title?: string;
  incoming?: boolean;
  skipHighlight?: boolean;
}): JSX.Element {
  if (price === undefined || price === null || incoming) {
    return <span> - </span>;
  }

  const formattedPrice = formatCurrency(price);

  if (formattedPrice && price < 0 && !skipHighlight) {
    return <Tag title={title} text={formattedPrice} squared backgroundColor="var(--color-tint)" />;
  }
  return <span title={title}>{formattedPrice}</span>;
}
